
$(document).ready(function(){
	function validatorEmail(value) {
		var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
	    var b = pattern.test(value);
	    return b;
	}

	function validatorString(value,min,max) {
		var b = false;
		var c = false;
		var n = value.length;
		if (typeof min != 'undefined') {
			if (min <= n) {
				b = true;
			}
		}
		else {
			b = true;
		}
		if (typeof max != 'undefined') {
			if (n <= max) {
				c = true;
			}
		}
		else {
			c = true;
		}
		return b && c;
	}

	function validatorNumber(value,min,max) {
		var b = false;
		var c = false;
		var n = parseInt(value);
		if (isNaN(n)) {
			return false;
		}
		else  {
			if (typeof min != 'undefined') {
				if (min <= value) {
					b = true;
				}
			}
			else {
				b = true;
			}
			if (typeof max != 'undefined') {
				if (n <= max) {
					c = true;
				}
			}
			else {
				c = true;
			}
			return b && c;
		}
	}

	function validatorNotEmpty(value) {
		if (value == '') {
			return false;
		}
		else {
			return true;
		}
	}

	function validatorTelephone(value) {
		var pattern = new RegExp('\^\\+[0-9]{1,4}\\.[0-9]{3,14}$');
		var b = pattern.test(value);
		return b;
	}

	function validatorDate(value) {
		var pattern = new RegExp('\^[12][0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$');
		var b = pattern.test(value);
		return b;
	}

	function validatorDouble2(value) {
		var pattern = new RegExp('\^\\-{0,1}[0-9]+\\.{0,1}[0-9]{0,2}$');
		var b = pattern.test(value);
		return b;
	}

	function validatorVat(value) {
		var v2 = value.substring(0,2);
		var b = false;
		if (v2 == 'AT') {
			b = /^ATU\d{8}$/.test(value);
		}
		if (v2 == 'BE') {
			b = /BE0\d{9}$/.test(value);
		}
		if (v2 == 'BG') {
			b = /BG\d{9,10}$/.test(value);
		}
		if (v2 == 'CY') {
			b = /CY\d{8}[A-Z]$/.test(value);
		}
		if (v2 == 'CZ') {
			b = /CZ\d{8,10}$/.test(value);
		}
		if (v2 == 'DE') {
			b = /DE\d{9}$/.test(value);
		}
		if (v2 == 'DK') {
			b = /DK\d{2}\s\d{2}\s\d{2}\s\d{2}$/.test(value);
		}
		if (v2 == 'EE') {
			b = /EE\d{9}$/.test(value);
		}
		if (v2 == 'EL') {
			b = /EL\d{9}$/.test(value);
		}
		if (v2 == 'ES') {
			b = /ES(([A-Z]\d{7}[A-Z])|(\d{8}[A-Z])|([A-Z]\d{8}))$/.test(value);
		}
		if (v2 == 'FI') {
			b = /FI\d{8}$/.test(value);
		}
		if (v2 == 'FR') {
			b = /FR[A-Z][A-Z]\s\D{9}$/.test(value);
		}
		if (v2 == 'GB') {
			b = /GB((\d{3}\s\d{4}\s\d{2}(\s\d{3}){0,1})|(GD\d{3})|(HA\d{3}))$/.test(value);
		}
		if (v2 == 'HR') {
			b = /HR\d{11}$/.test(value);
		}
		if (v2 == 'HU') {
			b = /HU\d{8}$/.test(value);
		}
		if (v2 == 'IE') {
			b = /IE((\dS\d{5}[A-Z])|(\d{7}WI))$/.test(value);
		}
		if (v2 == 'IT') {
			b = /IT\d{11}$/.test(value);
		}
		if (v2 == 'LT') {
			b = /LT\d{9}(\d{3}){0,1}$/.test(value);
		}
		if (v2 == 'LU') {
			b = /LU\d{8}$/.test(value);
		}
		if (v2 == 'LV') {
			b = /LV\d{11}$/.test(value);
		}
		if (v2 == 'MT') {
			b = /MT\d{8}$/.test(value);
		}
		if (v2 == 'NL') {
			b = /NL\d{9}B\d{2}$/.test(value);
		}
		if (v2 == 'PL') {
			b = /PL\d{10}$/.test(value);
		}
		if (v2 == 'PT') {
			b = /PT\d{9}$/.test(value);
		}
		if (v2 == 'RO') {
			b = /RO\d{2,10}$/.test(value);
		}
		if (v2 == 'SE') {
			b = /SE\d{12}$/.test(value);
		}
		if (v2 == 'SI') {
			b = /SI\d{8}$/.test(value);
		}
		if (v2 == 'SK') {
			b = /SK\d{10}$/.test(value);
		}
		if (b) {
			console.log('ja');
		}
		else {
			console.log('nee');
		}
		return b;
	}

	function validatorPassword(value,min,password) {
		var b = false;
		var c = false;
		var d = false;
		var e = false;
		var n = value.length;
		if (typeof min != 'undefined') {
			if (min <= n) {
				b = true;
			}
		}
		var lowerCaseLetters = /[a-z]/g;
  		if(value.match(lowerCaseLetters)) {
  			c = true;
  		}
  		var upperCaseLetters = /[A-Z]/g;
  		if(value.match(upperCaseLetters)) {
  			d = true;
  		}
  		var lowerCaseLetters = /[0-9]/g;
  		if(value.match(lowerCaseLetters)) {
  			e = true;
  		}
  		$('#'+password).trigger('change');
  		return b && c && d && e;
	}

	function validatorPassword2(value,password) {
		var v = $('#'+password).val();
		if (v == value) {
			return true;
		}
		else {
			return false;
		}
	}

	function validatorAddress(url,streetid,numberid,suffixid,postalcodeid,cityid,stateprovinceid,countryid) {
		var postalcode = $('#'+postalcodeid).val();
		var number = $('#'+numberid).val();
		var suffix = $('#'+suffixid).val();
		var country = $('#'+countryid).val();
		if ((postalcode.trim() == '') || (number.trim() == '') || (country.trim() == '')) {
			if (postalcode.trim() == '') {
				$('#'+postalcodeid).removeClass('is-valid');
				$('#'+postalcodeid).addClass('is-invalid');
			}
			else {
				$('#'+postalcodeid).removeClass('is-invalid');
				$('#'+postalcodeid).addClass('is-valid');
			}
		}
		else {
			var fd = new FormData();
			fd.append('tx_fwtranscript_ajaxtool[country]',country);
			fd.append('tx_fwtranscript_ajaxtool[number]',number);
			fd.append('tx_fwtranscript_ajaxtool[suffix]',suffix);
			fd.append('tx_fwtranscript_ajaxtool[postcode]',postalcode);
			$.ajax({
				url: url,
				type: "POST",
				contentType: false,
				processData: false,
				cache: false,
				data: fd,
				dataType: 'json',
				success: function(result) {
					if (result.error == 1) {
						$('#'+postalcodeid).removeClass('is-valid');
						$('#'+postalcodeid).addClass('is-invalid');
					}
					else if (result.error == 2) {
						if (postalcode.trim() == '') {
							$('#'+postalcodeid).removeClass('is-valid');
							$('#'+postalcodeid).addClass('is-invalid');
						}
						else {
							$('#'+postalcodeid).removeClass('is-invalid');
							$('#'+postalcodeid).addClass('is-valid');
						}
					}
					else {
						$('#'+streetid).removeClass('is-invalid');
						$('#'+numberid).removeClass('is-invalid');
						$('#'+suffixid).removeClass('is-invalid');
						$('#'+postalcodeid).removeClass('is-invalid');
						$('#'+cityid).removeClass('is-invalid');
						$('#'+stateprovinceid).removeClass('is-invalid');
						$('#'+countryid).removeClass('is-invalid');
						$('#'+streetid).addClass('is-valid');
						$('#'+numberid).addClass('is-valid');
						$('#'+postalcodeid).addClass('is-valid');
						$('#'+cityid).addClass('is-valid');
						$('#'+stateprovinceid).addClass('is-valid');
						$('#'+countryid).addClass('is-valid');
						$('#'+streetid).val(result.data.street);
						$('#'+numberid).val(result.data.houseNumber);
						$('#'+suffixid).val(result.data.houseNumberAddition);
						$('#'+postalcodeid).val(result.data.postcode);
						$('#'+cityid).val(result.data.city);
						$('#'+stateprovinceid).val(result.data.province);
					}
				},
				fail: function(error) {
					$('#'+postalcodeid).removeClass('is-valid');
					$('#'+postalcodeid).addClass('is-invalid');
				}
			});
		}
	}
	$('body').on('input change','[data-validate="1"]',function() {
		var validator = $( this ).data('validator');
		var opt = $( this ).data('validator-opt');
		var min = $( this ).data('validator-min');
		var max = $( this ).data('validator-max');
		var password = $( this ).data('validator-password');
		var euvatccid = $( this ).data('validator-euvatccid');
		var vatnoid = $( this ).data('validator-vatnoid');
		var vatnameid = $( this ).data('validator-vatnameid');
		var vataddressid = $( this ).data('validator-vataddressid');
		var value = $( this ).val();
		var streetid = $( this ).data('validator-streetid');
		var numberid = $( this ).data('validator-numberid');
		var suffixid = $( this ).data('validator-suffixid');
		var postalcodeid = $( this ).data('validator-postalcodeid');
		var cityid = $( this ).data('validator-cityid');
		var stateprovinceid = $( this ).data('validator-stateprovinceid');
		var countryid = $( this ).data('validator-countryid');
		var uri = $( this).data('validator-uri');
		var url = decodeURIComponent($('#'+uri).html());
		url = url.replace(/&amp;/g, '&');

		value = value.trim();
		var b = true;
		var d = true;
		if (opt == '1') {
			if (value == '') {
				$(this).removeClass('is-invalid');
				$(this).removeClass('is-valid');
				$(this).removeClass('is-mandatory');
				b = false;
			}
		}
		if (b) {
			var c = false;
			switch (validator) {
				case 'email':
					c = validatorEmail(value);
					break;
				case 'date':
					c = validatorDate(value);
					break;
				case 'string':
					c = validatorString(value,min,max);
					break;
				case 'double2':
					c = validatorDouble2(value);
					break;
				case 'number':
					c = validatorNumber(value,min,max);
					break;
				case 'notempty':
					c = validatorNotEmpty(value);
					break;
				case 'tel':
					c = validatorTelephone(value);
					break;
				case 'vat':
					c = validatorVat(value);
					break;
				case 'address':
					c = validatorAddress(url,streetid,numberid,suffixid,postalcodeid,cityid,stateprovinceid,countryid);
					d = false;
					break;
				case 'password':
					c = validatorPassword(value,min,password);
					break;
				case 'password2':
					c = validatorPassword2(value,password);
					break;
			}
			if (d) {
				if (c) {
					$(this).removeClass('is-invalid');
					$(this).removeClass('is-mandatory');
					$(this).addClass('is-valid');
				}
				else {
					if (value == "") {
						$(this).addClass('is-mandatory');
						$(this).removeClass('is-invalid');
						$(this).removeClass('is-valid');
					}
					else {
						$(this).addClass('is-invalid');
						$(this).removeClass('is-valid');
						$(this).removeClass('is-mandatory');
					}
				}
			}
		}
	})
	$('[data-validate="1"]').trigger('change');
});



